import {configureStore} from '@reduxjs/toolkit'
import sidebarReducer from './sidebar'
import authReducer from './auth'
import resourcesReducer from './resources'
import heartbeatsReducer from './heartbeats'
import monitoringReducer from './monitoring'
import alertReducer from './alert'
import customerReducer from './customer-settings'
import teamsReducer from './teams'
import membersReducer from './members'
import feedbackReducer from './feedback'
import voucherReducer from './voucher'
import paymentReducer from './payment'
import automationReducer from './automation'
import integrationsReducer from './integration'
import statuspageReducer from './statuspage'
import plansReducer from './plans'
import incidentManagementReducer from './incident-management'
import serverMonitoringReducer from './server-monitoring'
import logManagementReducer from './log-management'
import popupReducer from './popup'
import phoneCallReducer from './phone-call'
import securityReducer from './security'

export default configureStore({
    reducer: {
        sidebar: sidebarReducer,
        auth: authReducer,
        resources: resourcesReducer,
        monitoring: monitoringReducer,
        server_monitoring: serverMonitoringReducer,
        alert: alertReducer,
        heartbeats: heartbeatsReducer,
        customer_settings: customerReducer,
        teams: teamsReducer,
        members: membersReducer,
        feedback: feedbackReducer,
        voucher: voucherReducer,
        payment: paymentReducer,
        automation: automationReducer,
        integrations: integrationsReducer,
        statuspage: statuspageReducer,
        plans: plansReducer,
        incident_management: incidentManagementReducer,
        log_management: logManagementReducer,
        popup: popupReducer,
        phone_call: phoneCallReducer,
        security: securityReducer
    }
})
